<section class="main-wrap inner-views dashboard-wrap lens-module single-vision"
  [ngClass]="{ 'menu-open in': !toggleClass }">

  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>

      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>

  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>

    <div class="content-container products-container single-product lens-module" [class]="currentParentClass">
      <div class="row">
        <div class="col-md-6">
          <div class="lens-module-data">

            <div class="collapse collapse-lens6 collapse-lens43">
              <div class="card-body">
                <div class="figure-wrap">
                  <img src="/assets/images/products/lens-selection/Bifocal-Progressive-graphics.jpg" alt="Bifocal Polycarbonate"/>
                </div>
              </div>
            </div>

            <div class="collapse collapse-lens8">
              <div class="card-body">
                <div class="figure-wrap">
                  <img src="/assets/images/products/lens-selection/Progressive-Lens-graphics.jpg" alt="Progressive Lens"/>
                </div>
              </div>
            </div>

            <div class="collapse collapse-lens22 collapse-lens44">
              <div class="card-body">
                <div class="figure-wrap">
                  <img src="/assets/images/products/lens-selection/Digital-Progressive-Lens-graphics.jpg" alt="Digital Progressive"/>
                </div>
              </div>
            </div>

            <div class="collapse collapse-lens23 collapse-lens45">
              <div class="card-body">
                <div class="figure-wrap">
                  <img src="/assets/images/products/lens-selection/Freeform-Progressive-Lens-graphics.jpg" alt="Freeform Progressive Lens"/>
                </div>
              </div>
            </div>

            <div class="product-data-box">
              <app-product-data [tempCartEvents]="tempCartEventsSubject.asObservable()"></app-product-data>
            </div>

          </div>
        </div>

        <div class="col-md-6">
          <div class="prod-col-in">
            <span class="back-to-previous">
              <a (click)="back()"><img height="10" src="assets/images/icons/angle-right-solid.svg" width="10" alt="Angle Right ICon"/>Back to Prescription Type</a>
            </span>
            <h2 class="prod-title">Lens Selection</h2>

            <div class="progress" style="height: 7px;">
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active"
              role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active"
              role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar"
              role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar"
              role="progressbar" style="width: 25%;"></div>
            </div>

            <div class="clearfix"></div>
            <div class="col-md-12 module-non-prescription">
              <h3>Bifocal / Progressive Lens</h3>
            </div>
            <div class="col-md-12 module-prescription-options">
              <div class="accordion" id="accordion-lens">
                @for (l of progressiveLenses; track $index; let i = $index) {
                  <div class="card" [ngClass]="{'card-has-orange-text' : i == 0}">
                    @if (i == 0) {
                      <span class="orange-outlined-text">Invisible Bifocal Lenses (Progressive)</span>
                    }
                    <div class="card-header" id="lens-card-header">
                      <input #lens class="form-check-input lens-check"
                        type="radio"
                        name="radioLensSelection"
                        [attr.id]="l.lensId"
                        value=""
                        [attr.aria-label]="l.lensId"
                        data-toggle="collapse"
                        [attr.data-target]="'.multi-collapse' + l.lensId"
                        [attr.aria-controls]="l.lensId + '' + l.lensId +'2'"
                        (click)="selectLens(l.lensId.toString())">
                      <h3 class="mb-0">
                        <label class="btn btn-link btn-block text-left"
                          data-toggle="collapse"
                          [attr.data-target]="'.multi-collapse' + l.lensId"
                          [attr.aria-controls]="l.lensId + '' +  l.lensId +'2'"
                          type="button"
                          [attr.for]="l.lensId"
                          (click)="selectLens(l.lensId.toString())">
                          <span class="title-wrap">{{l.lensName}}</span><span class="acc-price-wrap">{{l.price | currency}}</span>
                        </label>
                      </h3>
                    </div>
                    <div [attr.aria-labelledby]="l.lensId"
                      [attr.class]="'collapse multi-collapse' + l.lensId"
                      data-parent="#accordion-lens"
                      [attr.id]="l.lensId">
                      <div class="card-body">
                        <p>
                          {{l.lensDescription}}
                        </p>
                      </div>
                    </div>
                  </div>
                }
                <div class="card card-has-orange-text">
                  <span class="orange-outlined-text">Traditional Bifocal Lenses (WITH Lines)</span>
                  @for (l of bifocalLenses; track $index; let i = $index) {
                    <div class="card-header" id="lens-card-header">
                      <input #lens class="form-check-input lens-check"
                        type="radio"
                        name="radioLensSelection"
                        [attr.id]="l.lensId"
                        value=""
                        [attr.aria-label]="l.lensId"
                        data-toggle="collapse"
                        [attr.data-target]="'.multi-collapse' + l.lensId"
                        [attr.aria-controls]="l.lensId + '' + l.lensId +'2'"
                        (click)="selectLens(l.lensId.toString())">
                      <h3 class="mb-0">
                        <label class="btn btn-link btn-block text-left"
                          data-toggle="collapse"
                          [attr.data-target]="'.multi-collapse' + l.lensId"
                          [attr.aria-controls]="l.lensId + '' +  l.lensId +'2'"
                          type="button"
                          [attr.for]="l.lensId"
                          (click)="selectLens(l.lensId.toString())">
                          <span class="title-wrap">{{l.lensName}}</span><span class="acc-price-wrap">{{l.price | currency}}</span>
                        </label>
                      </h3>
                    </div>
                    <div [attr.aria-labelledby]="l.lensId"
                      [attr.class]="'collapse multi-collapse' + l.lensId"
                      data-parent="#accordion-lens"
                      [attr.id]="l.lensId">
                      <div class="card-body">
                        <p>
                          {{l.lensDescription}}
                        </p>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="col-md-12 module-nav next-step">
                <button class="btn product-btn gray-btn" (click)="back()" type="button">Back</button>
                <button class="btn product-btn gray-btn" (click)="_orderManagerService.verifyLensSelection(isEditMode)" type="button">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


